import { dateTimeHandler } from "../../lib/dateTimeHandler";

const PrettyDate = ({ dateString, pattern }) => dateTimeHandler()(dateString).format(pattern);

export default PrettyDate;
